import * as React from 'react';
import type { Location } from '@hetivo/hetivo-lib-types';
import { cn } from '@hetivo/hetivo-lib-web-utils';
import { MapPin } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useMasterContext } from '&/master';

// ─── Props ────────────────────────────────────────────────────────────────────

export interface LocationRowProps {
  location: Location;
  onClose: () => void;
  territoryId: string;
}

// ─── Component ────────────────────────────────────────────────────────────────

export function LocationRow({ location, onClose, territoryId }: LocationRowProps): React.JSX.Element {
  const { selectSite, siteId: currentLocationId } = useMasterContext();
  const { t } = useTranslation('common');
  const isSelected = location.id === currentLocationId;

  const handleSelectLocation = (): void => {
    selectSite(location.id, territoryId);
    onClose();
  };

  return (
    <button
      className={cn(
        'flex items-center gap-2 px-2.5 py-2 w-full rounded-md transition-colors text-left group/location-row',
        isSelected ? 'bg-accent' : 'hover:bg-muted',
      )}
      onClick={handleSelectLocation}
      type="button"
    >
      <MapPin className="w-3.5 h-3.5 shrink-0" style={{ color: location.color }} />
      <span className="flex-1 text-xs truncate">{location.name}</span>

      {/* Select text — shown on hover for non-selected */}
      {!isSelected && (
        <span className="text-[11px] text-primary font-medium hidden group-hover/location-row:inline">
          {t('mainSelector.select')}
        </span>
      )}
    </button>
  );
}
